module.exports = __webpack_public_path__ + "img/icon-envelope.1385eea4.png";